/** 
 * Copyright (c) Open Carbon, 2020
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * App.js
 * 
 * App pulls together header, content and footer for display and routes paths correctly
 */ 

import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import clsx from 'clsx';

import CarbonMapApp from "./reducers";

import { withStyles } from '@material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';

// import Header from "./components/Header";
import Home from './components/Home';
import Menu from './components/Menu';
import Map from './components/Map';
import Areas from './components/Areas';
import ContextSliders from './components/ContextSliders';
import Graphs from './components/Graphs';
import NotFound from './components/NotFound';

import { globalstyle } from './styles/globalstyle';

let store = createStore(CarbonMapApp, applyMiddleware(thunk));

function Footer() {
  return (
  <Typography variant="body2" color="textSecondary" align="center">
      <Link variant="button" href="https://github.com/opencarbon/opencarbon.git">
          GitHub
      </Link>
  </Typography>
  );
}


/**
 * Main class for app that builds content and routes paths for application
 */
class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: true,
    };
  }

  handleDrawerOpen = () => {
    this.setState({open: true});
  };

  handleDrawerClose = () => {
    this.setState({open: false});
  };

  render() {
    const {classes} = this.props    
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);  

    return (

      <Provider store={store}>
        <BrowserRouter>

          <div className={classes.root}>
            <AppBar position="absolute" className={clsx(classes.appBar, this.state.open && classes.appBarShift)}>
              <Toolbar className={classes.toolbar}>
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.handleDrawerOpen}
                  className={clsx(classes.menuButton, this.state.open && classes.menuButtonHidden)}
                >
                  <MenuIcon />
                </IconButton>
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                  Open Carbon Map
                </Typography>
                <IconButton color="inherit">
                  {/* <Badge badgeContent={4} color="secondary">
                    <NotificationsIcon />
                  </Badge> */}
                </IconButton>
              </Toolbar>
            </AppBar>
            <Drawer
              variant="permanent"
              classes={{
                paper: clsx(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
              }}
              open={this.state.open}
            >
              <div className={classes.toolbarIcon}>
                <IconButton onClick={this.handleDrawerClose}>
                  <ChevronLeftIcon />
                </IconButton>
              </div>
              <Divider />

              <Menu />

            </Drawer>
            <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>

                  <Grid item xs={12} md={12} lg={7}>

                    <Map />

                  </Grid>
                  <Grid item xs={12} md={12} lg={5}>

                    <ContextSliders />

                    <Areas />

                  </Grid>

                  <Grid item xs={12}>

                    <Graphs />

                  </Grid>
                </Grid>
                <Box pt={4}>
                  <Footer />
                </Box>
              </Container>
            </main>
          </div>

        </BrowserRouter>
      </Provider>
    )
  }
}

export default withStyles(globalstyle)(App);
